<template>
<div>
  <div class="properties">
    <property :name="'סוג מנוי'" :value="subscriptionTypeText"/>
    <property :name="'תאריך חיוב הבא'" :value="'חיוב אחרון נכשל'"/>
  </div>
  <separator/>
  <update-credit-card-button/>
</div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import Property from './Property.vue';
import UpdateCreditCardButton from './components/UpdateCreditCardButton.vue';
import { SUBSCRIPTION_STATES } from '../../../../../constants/subscription-state';

export default {
  name: 'CanceledSettings',
  components: {
    Property,
    UpdateCreditCardButton,
    Separator: BaseUI.Separator,
  },
  computed: {
    ...mapState('subscriptionState', ['subscriptionState']),
    subscriptionTypeText() {
      return this.subscriptionState === SUBSCRIPTION_STATES.DORMANT_AFTER_CANCELED ? 'לא פעיל' : 'פעיל';
    },
  },
};
</script>

<style scoped lang="scss">
  @import "./settings";

  @include properties;

</style>



// WEBPACK FOOTER //
// src/pages/responsive-pages/authenticated/navigation-pages/account-settings/CanceledSettings.vue